import {
  Component,
  OnInit,
  OnChanges,
  Input,
  Output,
  EventEmitter,
  ViewChild
} from '@angular/core';

import { GoogleMap, MapGeocoder, MapGeocoderResponse } from '@angular/google-maps';
import { lastValueFrom } from 'rxjs';
import { SnackbarService } from '../../../../shared/components/snackbar/snackbar.service';
import { AuthService } from '../../../../core';
import { Point } from '../../..';

interface Location {
  lat: number;
  lng: number;
  zoom: number;
}

@Component({
  standalone: false,
  selector: 'app-maps',
  templateUrl: './maps.component.html',
  styleUrls: ['./maps.component.sass'],
})
export class MapsComponent implements OnInit, OnChanges {

  @ViewChild(GoogleMap) map!: GoogleMap;

  @Input() address!: string;
  @Input() addressList!: string[];
  @Input() locations!: any[];
  @Input() multiple = false;
  @Input() point?: Point;
  @Input() isDraggable = false;
  @Input() location!: Location;

  @Output() locationMarker = new EventEmitter<{ lat: number; lng: number }>();

  geoAddress!: string;

  constructor(
    private snackbarService: SnackbarService,
    private authService: AuthService,
    private geocoderService: MapGeocoder
  ) {
    if (!this.location && authService.getUser() && authService.getUser().locationCoordinates) { 
      const locationCountry = authService.getUser().locationCoordinates.split(',');
      this.location = {
        lat: +locationCountry[0],
        lng: +locationCountry[1],
        zoom: 16
      };
    }
  }

  ngOnInit(): void {
    this.multipleMaps();
  }

  ngOnChanges(): void {
    if (this.address) {
      this.updateOnMap(this.address);
    }

    if (this.point) {
      this.location = {
        lat: this.point.lat,
        lng: this.point.lng,
        zoom: 16
      };
    }

    this.ecommerceLocations();
  }

  multipleMaps(): void {
    if (this.multiple && this.locations?.length) {
      const firstValid = this.locations.find(l => l.lat && l.lng);
      if (firstValid) {
        this.location.lat = firstValid.lat;
        this.location.lng = firstValid.lng;
      }
    }
  }

  ecommerceLocations(): void {
    if (this.addressList?.length) {
      this.addressList.forEach(address => {
        this.updateOnMap(address);
      });
    }
  }

  async updateOnMap(address: string): Promise<void> {
    try {
      const response: MapGeocoderResponse = await lastValueFrom(
        this.geocoderService.geocode({
          address,
          componentRestrictions: {
            country: this.authService.getUser().country
          }
        })
      );

      if (response.results?.length) {
        const result = response.results[0];

        this.geoAddress = result.formatted_address;

        const coordinates: Location = {
          lat: result.geometry.location.lat(),
          lng: result.geometry.location.lng(),
          zoom: 16
        };

        this.location = coordinates;

        this.locationMarker.emit({
          lat: coordinates.lat,
          lng: coordinates.lng
        });

        this.snackbarService.show('Se encontró la dirección exacta', 'success');
        this.address = '';
      } else {
        this.snackbarService.show('No encontró la dirección exacta', 'error');
      }
    } catch (error) {
      this.snackbarService.show('No encontró la dirección exacta', 'error');
      console.error(error);
    }
  }

  markerDragEnd(event: google.maps.MapMouseEvent) {
    if (!event.latLng) return;

    this.locationMarker.emit({
      lat: event.latLng.lat(),
      lng: event.latLng.lng()
    });
  }

}